// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:where(.vuetify-styles) .v-data-table-footer {
  align-items: center;
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
  padding: 8px 4px;
}
:where(.vuetify-styles) .v-data-table-footer__items-per-page {
  align-items: center;
  display: flex;
  justify-content: center;
}
:where(.vuetify-styles) .v-data-table-footer__items-per-page > span {
  padding-inline-end: 8px;
}
:where(.vuetify-styles) .v-data-table-footer__items-per-page > .v-select {
  width: 90px;
}
:where(.vuetify-styles) .v-data-table-footer__info {
  display: flex;
  justify-content: flex-end;
  min-width: 116px;
  padding: 0 16px;
}
:where(.vuetify-styles) .v-data-table-footer__paginationz {
  align-items: center;
  display: flex;
  margin-inline-start: 16px;
}
:where(.vuetify-styles) .v-data-table-footer__page {
  padding: 0 8px;
}`, "",{"version":3,"sources":["webpack://./node_modules/vuetify/lib/components/VDataTable/VDataTableFooter.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;EACnB,aAAa;EACb,eAAe;EACf,yBAAyB;EACzB,gBAAgB;AAClB;AACA;EACE,mBAAmB;EACnB,aAAa;EACb,uBAAuB;AACzB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,WAAW;AACb;AACA;EACE,aAAa;EACb,yBAAyB;EACzB,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,mBAAmB;EACnB,aAAa;EACb,yBAAyB;AAC3B;AACA;EACE,cAAc;AAChB","sourcesContent":[".v-data-table-footer {\n  align-items: center;\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: flex-end;\n  padding: 8px 4px;\n}\n.v-data-table-footer__items-per-page {\n  align-items: center;\n  display: flex;\n  justify-content: center;\n}\n.v-data-table-footer__items-per-page > span {\n  padding-inline-end: 8px;\n}\n.v-data-table-footer__items-per-page > .v-select {\n  width: 90px;\n}\n.v-data-table-footer__info {\n  display: flex;\n  justify-content: flex-end;\n  min-width: 116px;\n  padding: 0 16px;\n}\n.v-data-table-footer__paginationz {\n  align-items: center;\n  display: flex;\n  margin-inline-start: 16px;\n}\n.v-data-table-footer__page {\n  padding: 0 8px;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
